module.exports = __webpack_public_path__ + "static/media/MINING.e03a6b87.png";